<!--<nav class="navbar">-->
<!--  <div class="logo" (click)="navigateHome()">Med-Visits</div>-->

<!--  <button class="menu-toggle" (click)="toggleMenu()">-->
<!--    ☰-->
<!--  </button>-->

<!--  <ul class="nav-links" [class.open]="isMenuOpen">-->
<!--    <li><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Home</a></li>-->
<!--    <li><a routerLink="/bookings" routerLinkActive="active">Bookings</a></li>-->
<!--    <li><a routerLink="/profile" routerLinkActive="active">Profile</a></li>-->
<!--  </ul>-->
<!--</nav>-->

<main class="content">
  @if (passwordExpiringIn !== null) {
    <div class="alert alert-warning d-flex align-items-center gap-3 m-3" role="alert">
      <i class="bi bi-exclamation-triangle-fill fs-5"></i>
      <div>
        <strong>Password Expiring Soon!</strong>
        <p class="mb-0">
          Your password will expire in
          <strong>{{ passwordExpiringIn }} {{ passwordExpiringIn === 1 ? 'day' : 'days' }}</strong
          >. <a href="/settings" class="alert-link">Update your password now</a>.
        </p>
      </div>
    </div>
  }

  <router-outlet></router-outlet>
</main>
